import { ValidateCallback } from "common/ui-components/form/types/validate.types";
import { ResolverError, ResolverSuccess } from "react-hook-form";

//A resolver to parse error messages into react-hooks-form ResolveResults format
export const validationResolver = async <FormValues extends {}>(
  validateCallback: ValidateCallback<FormValues>,
  values: FormValues
): Promise<ResolverSuccess<FormValues> | ResolverError<FormValues>> => {
  const resolverFieldErrors = validateCallback(values);
  return { values, errors: resolverFieldErrors };
};
